import React, { useEffect, useState } from "react";
import AlertPop from "./shared/AlertPop";
import ErrorMessage from "./shared/ErrorMessage";
import SharedButton from "./shared/SharedButton";
import SharedInput from "./shared/SharedInput";
import { app_url } from "./shared/Utils";

const INITIAL_DATA = {
  firstname: "",
  lastname: "",
  email: "",
  company: "",
  phone: "",
  comments: "",
};

const RequestAccess = ({ handleClose, showLoader }) => {
  const [reqAcc, setReqAcc] = useState(INITIAL_DATA);
  const [errorForm, setErrorForm] = useState(false);
  const [showAlert, setShowAlert] = useState(null);
  const [alertMessage, setAlertMessage] = useState(null);

  const setAlert = (type) => {
    setShowAlert(type);
  };

  useEffect(() => {
    setTimeout(() => {
      setShowAlert(null);
    }, 3000);
  }, [showAlert]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setReqAcc({
      ...reqAcc,
      [name]: value,
    });
    setErrorForm(false);
  };

  const submitRequestAccess = (user) => {
    let data = {
      FirstName: user.firstname,
      LastName: user.lastname,
      Email: user.email,
      CompanyName: user.company,
      PhoneNumber: user.phone,
      Comments: user.comments === "" ? "N/A" : user.comments,
    };
    showLoader(true);
    fetch(`${app_url}account/requestaccess`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        showLoader(false);
        setAlertMessage(data.message);
        if (data.status === "Error") {
          setAlert("danger");
        } else {
          setAlert("success");
          setReqAcc(INITIAL_DATA);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        showLoader(false);
        setAlert("danger");
      });
  };
  const handleRequestClick = () => {
    if (
      reqAcc.firstname !== "" &&
      reqAcc.lastname !== "" &&
      reqAcc.email !== "" &&
      reqAcc.company !== "" &&
      reqAcc.phone !== ""
    ) {
      submitRequestAccess(reqAcc);
    } else {
      setErrorForm(true);
    }
  };

  return (
    <>
      {showAlert === "success" ? (
        <AlertPop variant="success">
          <strong>
            <i className="fa fa-check alert-icon"></i> Success!
          </strong>
        </AlertPop>
      ) : (
        ""
      )}

      {showAlert === "danger" ? (
        <AlertPop variant="danger">
          <strong>
            <i className="fa fa-close alert-icon"></i> {alertMessage}
          </strong>
        </AlertPop>
      ) : (
        ""
      )}
      <div id="requestModal" className="request-modal">
        <div className="access-box">
          <div
            id="closeRequest"
            className="close-request"
            onClick={handleClose}
          >
            <i className="fa fa-close"></i>
          </div>
          <h2>Market Rates Access Request</h2>
          <div id="requestForm" className="request-form">
            <div className="form-flex">
              <div className="vd_input-wrapper w-50">
                <label htmlFor="firstname">First Name</label>
                <SharedInput
                  id="firstname"
                  name="First Name"
                  inputType="text"
                  inputChange={handleInputChange}
                  value={reqAcc.firstname}
                />
              </div>
              <div className="vd_input-wrapper w-50">
                <label htmlFor="lastname">Last Name</label>
                <SharedInput
                  id="lastname"
                  name="Last Name"
                  inputType="text"
                  inputChange={handleInputChange}
                  value={reqAcc.lastname}
                />
              </div>
              <div className="vd_input-wrapper w-50">
                <label htmlFor="email">Email Address</label>
                <SharedInput
                  id="email"
                  name="Email Address"
                  inputType="email"
                  inputChange={handleInputChange}
                  value={reqAcc.email}
                />
              </div>
              <div className="vd_input-wrapper w-50">
                <label htmlFor="company">Company Name</label>
                <SharedInput
                  id="company"
                  name="Company Name"
                  inputType="text"
                  inputChange={handleInputChange}
                  value={reqAcc.company}
                />
              </div>
              <div className="vd_input-wrapper w-50">
                <label htmlFor="phone">Phone Number</label>
                <SharedInput
                  id="phone"
                  name="Phone Number"
                  inputType="text"
                  inputChange={handleInputChange}
                  value={reqAcc.phone}
                />
              </div>
              <div className="vd_input-wrapper">
                <label htmlFor="comments">Additional Comments</label>
                <textarea
                  id="comments"
                  name="comments"
                  placeholder="Additional Comments"
                  rows="7"
                  className="form-control"
                  onChange={(e) => handleInputChange(e)}
                  value={reqAcc.comments}
                ></textarea>
              </div>
              <ErrorMessage
                id="requestError"
                errorClass={`request-error ${errorForm ? "" : "d-none"}`}
                message="Please fill all fields before submitting "
              />
              <div className="form-group request-button">
                <SharedButton
                  id="btn-request"
                  addClass="btn-request"
                  btnName="SUBMIT REQUEST"
                  handleClick={handleRequestClick}
                />
              </div>
            </div>
          </div>
          <div className="contact-us">
            Need help booking a reservation?
            <div className="contact-link">
              <a
                href="https://dwellworksliving.com/Default/ContactUs"
                target="_blank"
                rel="noreferrer"
              >
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RequestAccess;
